import React from "react"
import { Box, HStack } from "@chakra-ui/react"
import { FaGithubAlt, FaLinkedin, FaEnvelope } from "react-icons/fa"
import "./styles.scss"

export default function Footer () {
    const redirect = (link) => {
        if (typeof window !== "undefined")
            window.open(link, '_blank')
        
    }

    const sendMail = () => {
        if (typeof window !== "undefined")
            window.location.href = "mailto:riowongsoatmojo@gmail.com";
    }

    return (
        <Box py={20}>
            <HStack justifyContent="flex-end" spacing={8} >
                <FaGithubAlt className="footer-button" onClick={() => redirect('https://github.com/idea456')} fontSize={40}/>
                <FaLinkedin className="footer-button" onClick={() => redirect('https://www.linkedin.com/in/adrienne-rio/')}  fontSize={38}/>
                <FaEnvelope className="footer-button" onClick={() => sendMail()} fontSize={38}/>
            </HStack>
        </Box>
    )
}